// =====================================================================
// lib/motDePasse.js — règles du mot de passe à l'écran + jeton du lien « mot de passe oublié » (23-10-2026)
// =====================================================================
// Mêmes règles que le serveur (backend/src/lib/mot-de-passe.js : validatePasswordStrength) — le serveur décide,
// l'écran prévient avant l'envoi. Le jeton du lien est dans le fragment (#…) de l'adresse : le navigateur ne
// l'envoie jamais au serveur (ni dans l'adresse, ni dans le Referer) ; la page le renvoie dans le corps du POST.
// =====================================================================

// Une seule liste : l'indicateur coché en direct (label) et le refus avant envoi (message).
export const CRITERES = Object.freeze([
  { label: 'Au moins 6 caractères', message: 'Au moins 6 caractères', ok: (p) => String(p || '').length >= 6 },
  { label: 'Au moins une majuscule', message: 'Au moins une majuscule', ok: (p) => /[A-Z]/.test(String(p || '')) },
  { label: 'Au moins un caractère spécial', message: 'Au moins un caractère spécial (!@#$%...)', ok: (p) => /[^a-zA-Z0-9]/.test(String(p || '')) },
]);

/** Message si le mot de passe est trop faible, sinon null. */
export const erreurMotDePasse = (p) => CRITERES.find((c) => !c.ok(p))?.message ?? null;

/** Jeton lu dans le fragment de l'adresse (« #… ») ; null s'il manque ou n'a pas la forme d'un jeton. */
export function jetonDuFragment(fragment) {
  const j = String(fragment || '').replace(/^#/, '');
  return /^[A-Za-z0-9_-]{43}$/.test(j) ? j : null;
}
